import LancamentoBancarioService from "@/services/LancamentoBancarioService"
import moment from 'moment'

export const actions = {
    cadastrarLancamentoBancario: ({commit, dispatch}) => {
        commit('setModalCadastroLancamentoBancario', false)
        commit('setShowInputAnexoLancamentoBancario', false)
        commit('setLancamentoBancario', {
            numero_documento: "",
            data_lancamento: moment().format('YYYY-MM-DD'),
            data_competencia: moment().format('YYYY-MM-DD'),
            historico: "",
            portador_id: "",
            grupo_id: "",
            banco_id: "",
            valor: "",
            tipo: "",
            empresa_id: "",
            anexo: "",
        }),
        commit('setShowInputAnexoLancamentoBancario', true)
        dispatch('setModalCadastroLancamentoBancario', true)
    },
    listarLancamentoBancario: ({commit}, data) => {
        commit('setOverlay', true)
        LancamentoBancarioService.listar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('setLancamentosBancarios', res.data)

        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    visualizarLancamentoBancario: ({commit, dispatch}, data) => {
        commit('setLancamentoBancario', data)
        dispatch('setModalCadastroLancamentoBancario', true)
    },
    
    salvarLancamentoBancario: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        LancamentoBancarioService.salvar(data)
        .then(res => {
            commit('setShowInputAnexoLancamentoBancario', false)
            commit('setLancamentoBancario', res.data)
            commit('addLancamentoBancario', res.data)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Registro salvo.')
        })
        .then(() => {
            commit('setShowInputAnexoLancamentoBancario', true)
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar.')
        })
    },
    atualizarLancamentoBancario: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        LancamentoBancarioService.atualizar(data)
        .then(res => {
            commit('setLancamentoBancario', res.data)
            commit('setShowInputAnexoLancamentoBancario', false)
            dispatch('listarLancamentoBancario')
            commit('setOverlay', false)
            commit('snackbarInfo', 'Registro atualizado.')
        })
        then(() => {
            commit('setShowInputAnexoLancamentoBancario', true)
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirLancamentoBancario: ({commit, dispatch}, data) => {
        dispatch('setModalExcluirLancamentoBancario', false)
        dispatch('setModalCadastroLancamentoBancario', false)
        commit('setOverlay', true)
        LancamentoBancarioService.excluir(data.id)
        .then(res => {
            commit('removeLancamentoBancario', data)
            commit('setOverlay', false)
            commit('snackbarError', 'Registro excluído.')
        })
        .catch(e => {
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    setModalCadastroLancamentoBancario: ({commit}, status) => {
        commit('setModalCadastroLancamentoBancario', false)
        setTimeout(() => {
            commit('setModalCadastroLancamentoBancario', status)
        }, 100);
    },
    setModalExcluirLancamentoBancario: ({commit}, status) => {
        commit('setModalExcluirLancamentoBancario', false)
        setTimeout(() => {
            commit('setModalExcluirLancamentoBancario', status)
        }, 100);
    },
    imprimirComprovanteLancamentoBancario: ({commit}, id) => {
        commit('setOverlay', true)
        LancamentoBancarioService.imprimir(id)
        .then(res => {
            commit('setOverlay', false)
            commit('setModalPrint', res.data.pdf_link)
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao imprimir comprovante.')
        })
    }
}

export default {}